import { useDeepLinkContext } from '@/providers/deep-link.provider';
export function useDeepLink() {
  return useDeepLinkContext();
}